
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, Filter } from "lucide-react";

interface SearchFilterProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filterOption: "all" | "present" | "absent" | "penalized";
  onFilterChange: (value: "all" | "present" | "absent" | "penalized") => void;
}

export const SearchFilter = ({ 
  searchTerm, 
  onSearchChange, 
  filterOption, 
  onFilterChange 
}: SearchFilterProps) => {
  return (
    <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2 mb-4">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-white/50" />
        <Input
          placeholder="Buscar alumno..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 bg-[#253B3D] border-[#00C1D6]/30 text-white placeholder:text-white/50"
        />
      </div>
      
      <div className="w-full sm:w-48">
        <Select
          value={filterOption}
          onValueChange={(value) => onFilterChange(value as "all" | "present" | "absent" | "penalized")}
        >
          <SelectTrigger className="bg-[#253B3D] border-[#00C1D6]/30 text-white">
            <div className="flex items-center">
              <Filter className="h-4 w-4 mr-2 text-white/70" />
              <SelectValue placeholder="Filtrar por" />
            </div>
          </SelectTrigger>
          <SelectContent className="bg-[#253B3D] border-[#00C1D6]/30 text-white">
            <SelectItem value="all">Todos</SelectItem>
            <SelectItem value="present">Presentes</SelectItem>
            <SelectItem value="absent">Ausentes</SelectItem>
            <SelectItem value="penalized">Penalizados</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
